import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface UserNameValidatorError {
  badUserName: true;
}

export const UserNameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const REGEX_NAME = '^([0-9A-zÀ-ú\\-\\s])*$'; // @@@
  const regexp = new RegExp(REGEX_NAME);
  return !control.value || regexp.test(control.value) ? null : ({ badUserName: true } as UserNameValidatorError);
};
